import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_list, { class: "rounded-xl border-none flex-grow-0 flex-shrink-1" }, {
    default: _withCtx(() => [
      (_ctx.startDate && _ctx.endDate)
        ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.periodTitle), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item_subtitle, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.period), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.amountDeclared)
        ? (_openBlock(), _createBlock(_component_v_list_item, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("b", null, "Montant déclaré", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_list_item_subtitle, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(_ctx.amountDeclared, undefined)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.paymentsInfo)
        ? (_openBlock(), _createBlock(_component_v_list_item, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("b", null, "Montant payé", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_list_item_subtitle, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(_ctx.paymentsInfo.amountPaid, undefined)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.paymentsInfo)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.paymentsInfo.paymentsList, (payment) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: payment.iban
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_subtitle, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(payment.iban), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_list_item_subtitle, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(payment.bic), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_list_item_subtitle, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(payment.amount, undefined)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.translatedStatus)
        ? (_openBlock(), _createBlock(_component_v_list_item, { key: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("b", null, "Statut", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_list_item_subtitle, { class: "line-clamp-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translatedStatus), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.translatedSendDate)
        ? (_openBlock(), _createBlock(_component_v_list_item, { key: 5 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("b", null, "Date d'envoi", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_list_item_subtitle, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translatedSendDate), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.mtaeId)
        ? (_openBlock(), _createBlock(_component_v_list_item, { key: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("b", null, "EDI", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_list_item_subtitle, { class: "line-clamp-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.mtaeId), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.errors.length)
        ? (_openBlock(), _createBlock(_component_v_list_item, { key: 7 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("b", null, "Erreurs", -1)
                ])),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                return (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                  key: index,
                  class: "line-clamp-5"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.num) + " - " + _toDisplayString(error.detail), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}